import { Unit } from '../models/unit';
import { Action } from '@ngrx/store';
import { UnitEmployment } from '../models/unitEmployment';

export enum ActionTypes {
  LoadUnits = '[Unit] Load Units',
  LoadUnitsSuccess = '[Unit] Load User Units Success',
  LoadUnit = '[Unit] Load Unit',
  LoadUnitSuccess = '[Unit] Load Unit Success',
  LoadUnitUsers = '[Unit] Load Unit Users',
  LoadUnitUsersSuccess = '[Unit] Load Unit Users Success',
  UpdateUnit = '[Unit] Update Unit',
  UpdateUnitSuccess = '[Unit] Update Unit Success',
  LoadUnitsFail = '[Unit] Load Units Fail',
  SelectUnit = '[Unit] Select Unit',
  SelectUnitEmployment = '[UnitEmployment] Select UnitEmployment',
  UpdateUnitEmployment = '[UnitEmployment] Update UnitEmployment',
  UpdateUnitEmploymentSuccess = '[UnitEmployment] Update UnitEmployment Success',
  DeleteUnitEmployment = '[UnitEmployment] Delete UnitEmployment',
  DeleteUnitEmploymentSuccess = '[UnitEmployment] Delete UnitEmployment Success',
  DeleteUnit = '[Unit] Delete Unit',
  DeleteUnitSuccess = '[Unit] Delete Unit Success',
  UnitEmploymentError = '[UnitEmployment] UnitEmployment Error',
  UnitActionError = '[Unit] Unit Action Error',
}

export class LoadUnits implements Action {
  readonly type = ActionTypes.LoadUnits;

  constructor(public payload: { id: number; focusParent?: boolean }) {}
}

export class LoadUnitsSuccess implements Action {
  readonly type = ActionTypes.LoadUnitsSuccess;

  constructor(public payload: { units: Unit[]; focusParent?: boolean }) {}
}

export class LoadUnit implements Action {
  readonly type = ActionTypes.LoadUnit;

  constructor(public payload: { unit: Unit }) {}
}

export class LoadUnitSuccess implements Action {
  readonly type = ActionTypes.LoadUnitSuccess;

  constructor(public payload: { unit: Unit }) {}
}

export class LoadUnitsFail implements Action {
  readonly type = ActionTypes.LoadUnitsFail;

  constructor(public payload: { errors: any }) {}
}

export class UpdateUnitSuccess implements Action {
  readonly type = ActionTypes.UpdateUnitSuccess;

  constructor(public payload: { unit: Unit }) {}
}

export class UpdateUnit implements Action {
  readonly type = ActionTypes.UpdateUnit;

  constructor(public payload: { unit: Unit }) {}
}

export class SelectUnit implements Action {
  readonly type = ActionTypes.SelectUnit;

  constructor(public payload: { unit: Unit }) {}
}

export class LoadUnitUsers implements Action {
  readonly type = ActionTypes.LoadUnitUsers;

  constructor(public payload: { id: number }) {}
}

export class LoadUnitUsersSuccess implements Action {
  readonly type = ActionTypes.LoadUnitUsersSuccess;

  constructor(public payload: { users: Array<any> }) {}
}

export class UpdateUnitEmployment implements Action {
  readonly type = ActionTypes.UpdateUnitEmployment;
  constructor(public payload: { unitEmployment: UnitEmployment }) {}
}

export class UpdateUnitEmploymentSuccess implements Action {
  readonly type = ActionTypes.UpdateUnitEmploymentSuccess;
  constructor(public payload: { unitEmployment: UnitEmployment }) {}
}

export class SelectUnitEmployment implements Action {
  readonly type = ActionTypes.SelectUnitEmployment;
  constructor(public payload: { unitEmployment: UnitEmployment }) {}
}

export class DeleteUnitEmployment implements Action {
  readonly type = ActionTypes.DeleteUnitEmployment;
  constructor(public payload: { unitEmployment: UnitEmployment }) {}
}

export class DeleteUnitEmploymentSuccess implements Action {
  readonly type = ActionTypes.DeleteUnitEmploymentSuccess;
  constructor(public payload: any) {}
}

export class DeleteUnit implements Action {
  readonly type = ActionTypes.DeleteUnit;
  constructor(public payload: { unitId: number }) {}
}

export class DeleteUnitSuccess implements Action {
  readonly type = ActionTypes.DeleteUnitSuccess;
  constructor(public payload: any) {}
}

export class UnitEmploymentError implements Action {
  readonly type = ActionTypes.UnitEmploymentError;
  constructor(public payload: { error: any }) {}
}

export class UnitActionError implements Action {
  readonly type = ActionTypes.UnitActionError;
  constructor(public payload: { error: any }) {}
}

export type Actions =
  | LoadUnits
  | LoadUnitsSuccess
  | LoadUnit
  | LoadUnitSuccess
  | LoadUnitsFail
  | UpdateUnit
  | UpdateUnitSuccess
  | SelectUnit
  | LoadUnitUsers
  | LoadUnitUsersSuccess
  | SelectUnitEmployment
  | UpdateUnitEmployment
  | UpdateUnitEmploymentSuccess
  | DeleteUnitEmployment
  | DeleteUnitEmploymentSuccess
  | DeleteUnit
  | DeleteUnitSuccess
  | UnitEmploymentError
  | UnitActionError;
